import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { AppShellLayout } from './AppShellLayout';

export function ProtectedLayout() {
  const { jwt, loading } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress color="primary" />
      </Box>
    );
  }

  if (!jwt) {
    return <Navigate to="/login" replace />;
  }

  return <AppShellLayout />;
}
